import { Spinner } from "@clarkinc/zest-design-system/ui";
import React from "react";
import Header from "../Header";
import { cls } from "@wss/cls";

interface LoadingViewProps {
  itemNumber: string;
  productLink: string;
  productName: string;
  reviews: {
    rating: number;
    count: number;
  };
  isTrs: boolean;
  showHeader?: boolean;
}

const LoadingView = ({
  itemNumber,
  productLink,
  productName,
  reviews,
  isTrs,
  showHeader = false,
}: LoadingViewProps) => {
  // adding a mounted check before this fixes hydration issues, but causes a blank screen to appear.
  // TODO: revisit with react 19

  return (
    <div className="container bg-[rgba(238,240,237,1)]">
      {!isTrs && showHeader && (
        <Header
          itemNumber={itemNumber}
          productLink={productLink}
          name={productName}
          reviews={{
            rating: reviews?.rating,
            count: reviews?.count,
          }}
        />
      )}
      <div
        className={cls(
          "flex h-[50svh] justify-center mx-auto pt-14 pb-21 xsl:pt-21 xsl:pb-24 lg:pt-28 lg:pb-[174px]",
          { "h-[50svh]": isTrs, "h-[40svh]": !isTrs },
        )}
        aria-busy="true"
      >
        <Spinner
          theme="wss"
          size="2xlarge"
          color="dark"
          label="Loading"
          labelPosition="stacked"
          className="justify-self-center"
        />
      </div>
    </div>
  );
};

export default LoadingView;
